import axios from './axios';
import { getFromS3, uploadToS3 } from './files';

export const getAgents = () => axios.get('/analyzer/v1/admin/agents');

export const createAgent = (form) => axios.post('/analyzer/v1/admin/agents', form);

export const updateAgent = (form) => axios.put('/analyzer/v1/admin/agents/' + form.id, form);

export const removeAgent = (id) => axios.delete('/analyzer/v1/admin/agents/' + id);

export const a2aInfo = (url) => axios.post('/analyzer/v1/admin/agents/a2a/info', { url });

export const createA2A = (url) => axios.post('/analyzer/v1/admin/agents/a2a', { url });

export const getTools = () => axios.get('/analyzer/v1/admin/tools');

/**
 * Uploads a file to S3 for Copilot processing
 * @param {File} file - The file to upload
 * @returns {Promise<string>} The S3 key to send to the backend
 */
export const uploadCopilotFile = (file) =>
    axios
        .post('/analyzer/v1/files', { name: file.name })
        .then(({ data }) => uploadToS3(data.url, file).then(() => data.id));

/**
 * Downloads the raw payload of a Copilot resource artifact.
 *
 * Backed by `POST /analyzer/v1/artifacts`, which returns a short-lived signed
 * S3 URL (`{ url }`). The signed URL is fetched directly (no auth headers, to
 * avoid breaking the S3 signature) and the file body is returned as text.
 *
 * @param {Object} download - Artifact `download` descriptor
 * @param {string} download.bucket - Storage bucket
 * @param {string} download.name - File name inside the bucket
 * @returns {Promise<string>} Raw file content
 */
export const downloadCopilotArtifact = ({ bucket, name } = {}) =>
    axios.post('/analyzer/v1/artifacts', { bucket, name }).then(({ data }) => {
        if (!data?.url) throw new Error('Missing signed URL for artifact');
        return getFromS3(data.url).then(({ data: body }) => body);
    });
